import { dev } from "$app/environment"
import { debugLoggingEnabled } from "../stores/debugStore"
import { get } from "svelte/store"

// Safe logging that only runs in development mode
export const debugLog = (message: string, data?: any) => {
  if (!get(debugLoggingEnabled)) return // Skip if debug logging is disabled

  if (data) {
    // Sanitize data to remove sensitive information
    const sanitizedData = sanitizeForLogging(data)
    console.log(`[DEBUG] ${message}`, sanitizedData)
  } else {
    console.log(`[DEBUG] ${message}`)
  }
}

// Sanitize data to remove sensitive information
function sanitizeForLogging(data: any): any {
  if (!data) return data

  // For arrays
  if (Array.isArray(data)) {
    return data.map((item) => sanitizeForLogging(item))
  }

  // For objects
  if (typeof data === "object") {
    const result: Record<string, any> = {}

    for (const key in data) {
      // Skip functions
      if (typeof data[key] === "function") continue

      // Sanitize sensitive keys
      if (isSensitiveKey(key)) {
        result[key] =
          typeof data[key] === "string"
            ? "***[REDACTED]***"
            : "[REDACTED OBJECT]"
      } else {
        // Recursively sanitize nested objects
        result[key] = sanitizeForLogging(data[key])
      }
    }
    return result
  }

  return data
}

// Check if a key might contain sensitive data
function isSensitiveKey(key: string): boolean {
  const sensitivePatterns = [
    "key",
    "token",
    "secret",
    "password",
    "auth",
    "jwt",
    "api",
    "credentials",
    "private",
  ]

  const lowerKey = key.toLowerCase()
  return sensitivePatterns.some((pattern) => lowerKey.includes(pattern))
}
